import React from 'react';
import moment from 'moment';
import Image from 'next/image';
import logo from '../../assets/fyllo.png';
import Link from 'next/link';
import MetaHead from '@/Components/MetaHead';

import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';
import ContentTitle from '@/Components/ContentTitle';
const { parse } = require('rss-to-json');


const fetchMediumBlogUrl = 'https://medium.com/feed/@fyllotech'


export default function Blogs({ Blogs }) {
  const setThumbnail = (blog) => {
    const popularImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
    const thumbnail = blog?.thumbnail;
    const descriptionImg = blog?.description.toString().match(/<img[^>]+src="([^">]+)"/)?.[1];
    let imgSrc = '';
    if (thumbnail && popularImageExtensions.some((ext) => thumbnail.toLowerCase().endsWith(ext))) {
      imgSrc = thumbnail;
    }
    else if (descriptionImg) {
      imgSrc = descriptionImg;
    }
    else {
      imgSrc = logo;
    }
    return imgSrc;
  };
  return (
    <div>
      <MetaHead title="Blogs | Fyllo" />
      <section className="mt-0 px-6 pt-12 pb-10 lg:pt-[60px] lg:pb-20">
        <div className="container mx-auto">
          <div className="-mx-4 flex flex-wrap justify-center">
            <div className="w-full px-4">
              <div className="mx-auto mb-[40px] max-w-[510px] text-center lg:mb-20">
                <span className="text-green-700 mb-2 block text-lg font-semibold">Our Blogs</span>
                <MainHeading text="Our Recent News" />
                <SubHeading text="Explore our blogs to read about technology, agriculture, climate and crops. Get a glimpse in Fyllo's world through our writings." />
              </div>
            </div>
          </div>
          <div className="-mx-4 flex flex-wrap">
            {Blogs?.map((blog, i) => {
              return (
                <Link
                  href={'blogs/' + encodeURIComponent(blog?.title)}
                  key={i}
                  className="w-full px-4 md:w-1/2 lg:w-1/3"
                >
                  <div className="mx-auto mb-10 max-w-[370px]">
                    <div className="mb-8 overflow-hidden rounded">
                      <Image
                        width={1600}
                        height={900}
                        src={setThumbnail(blog)}
                        alt={blog?.title}
                        className="h-[230px] object-video object-cover"
                        sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
                      />
                    </div>
                    <div>
                      <span className="border-gray-200 border-2 mb-5 inline-block rounded-full py-1 px-4 text-center text-xs font-semibold leading-loose text-fyllo-800">
                        {moment(blog?.published).format('DD MMM YYYY')}
                      </span>
                      <ContentTitle text={blog?.title} styles=" md:text-lg lg:text-xl" />
                      <div className="text-body-color text-base flex gap-2 flex-wrap">
                        {blog?.categories?.map((cat, i) => {
                          return (
                            <div
                              key={'categories-' + i}
                              className="max-w-max flex-auto min-w-min border border-slate-200 px-3 py-1 rounded-full"
                            >
                              {cat}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
            <div></div>
          </div>
        </div>
      </section>
    </div>
  );
}

// export async function getStaticProps() {
//   const response = await fetch(fetchMediumBlogUrl);
//   const Blogs = (await response.json())?.items;
//   return {
//     props: { Blogs },
//     revalidate: 60,
//   };
// }

export async function getServerSideProps() {
    const res = await parse(fetchMediumBlogUrl, {
      headers: {
       'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/110.0.0.0 Safari/537.36'
      }
   })

    const blogs = (res?.items || []).map(blog => ({
      ...blog,
      title: blog.title,
      description: blog?.description || blog?.content || "",
 }));
    return {
      props: {
        Blogs: blogs|| [], 
      },
    };
} 